module.exports = __webpack_public_path__ + "img/introduce-logo.5fc18a2f.png";